<template>
  <tr
    :class="[
      'ms-tr',
      dataRow.IsBold ? 'ms-format-bold' : '',
      dataRow.IsItalic ? 'ms-format-italic' : '',
      {'action-hover': showRowAction && actionInline},
    ]"
    tabindex="0"
    :indexRow="dataRow.rowIndex || index"
    v-if="!dataRow.isHide"
  >
    <td v-if="multiple" class="ms-td multiple-cell sticky ms-col-td-multiple">
      <ms-checkbox
        :checked="isChecked"
        @input="checkMultiple"
        class="justify-center"
        ref="multiple"
        checkOnly
        :disabled="disabledCheckedMultipleTbody"
        :key="0"
      />
    </td>
    <td :key="0" v-if="serial" class="ms-td serial text-center" :class="{sticky: hasLockColumn}">
      {{ pageSize * (currentPage - 1) + index + 1 }}
    </td>
    <td
      v-for="(col, index) in columns"
      :key="col.dataField"
      class="ms-td ms-col-td"
      :class="[col.cssCellClass, {sticky: col.lock}, index === columns?.length - 1 ? 'ms-col-td-last' : '']"
      :style="styleWidth(col, false)"
      :ref="`td-${col.dataField}`"
    >
      <component
        v-if="col.template"
        :is="col.template"
        :data="dataRow"
        :column="col"
        :dataRow="dataRow"
        :col="col"
        :rowSelected="rowSelected"
        :isSelected="isSelected"
      ></component>
      <div v-else-if="col.isSerial" :class="[`justify-center`, col.cssClass]">
        <span>{{ index + 1 }}</span>
      </div>

      <!-- Kiểu Text nhưng có dạng nhiều dòng value= MORE_DETAILS-->
      <div
        v-else-if="dataRow[col.dataField] === 'MORE_DETAILS'"
        :class="[`text-${col.align || 'left'}`, col.cssClass, 'text-overflow', 'icon24', 'more-rows']"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
        @click="viewMoreDetails(col, dataRow)"
      >
        <span></span>
      </div>
      <div
        :class="[
          `text-${col.align || 'left'}`,
          col.cssClass,
          'text-overflow',
          $ms.constant.FormatType.Checkbox,
          col.formatType,
        ]"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
        v-else
      >
        <!-- v-tooltip="{ content:titleToolTip(dataRow, col), placement: 'top'}" -->
        <!-- kiểu checkbox -->
        <span
          v-if="col.formatType === $ms.constant.FormatType.Checkbox"
          class="cell-checkbox"
          :ref="`text-${col.dataField}`"
        >
          <div class="icon" :class="{checked: dataRow[col.dataField]}"></div>
        </span>
        <!-- kiểu html -->
        <div
          v-else-if="col.formatType === $ms.constant.FormatType.Html"
          class="customStyleHtml"
          v-html="dataRow[col.dataField]"
          :title="titleToolTip(dataRow, col)"
        ></div>
        <!-- kiểu Avatar + Text -->
        <!-- <span
          v-else-if="col.formatType === $ms.constant.FormatType.AvatarText"
          :class="[`text-${col.align || 'left'} ${col.linkedForm ? 'text-link' : ''}`, 'avatar-text-cell']"
          :ref="`text-${col.dataField}`"
          :title="titleToolTip(dataRow, col)"
          @click="viewLinkedForm(col, dataRow)"
        >
          <div class="avatar-container">
            <img
              v-if="getAvatarSrc(col, dataRow)"
              :src="getAvatarSrc(col, dataRow)"
              alt="avatar"
              :class="[col.isLogo ? 'logo-img' : 'avatar-image']"
              @error="handleOnGetImgError"
            />
            <div
              v-else
              class="avatar-placeholder"
              :style="{
                backgroundColor: getRandomAvatarColor(
                  dataRow[col.avatarTextField] || dataRow[col.dataField],
                  col.useIdBasedColor || false,
                ),
              }"
            >
              {{ getAvatarInitial(dataRow[col.avatarTextField] || dataRow[col.dataField]) }}
            </div>
          </div>
          <span class="text-content">
            {{
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                optionFormat: col.optionFormat,
                enumName: col.enum,
              })
            }}
          </span>
        </span> -->
        <!-- kiểu Icon + Text -->
        <span
          v-else-if="col.formatType === $ms.constant.FormatType.IconText"
          :class="[`text-${col.align || 'left'} ${col.linkedForm ? 'text-link' : ''}`, 'icon-text-cell']"
          :ref="`text-${col.dataField}`"
          :title="titleToolTip(dataRow, col)"
          @click="viewLinkedForm(col, dataRow)"
        >
          <i :class="dataRow[col.iconField]" v-if="dataRow[col.iconField]"></i>
          <span class="text-content">
            {{
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                optionFormat: col.optionFormat,
                enumName: col.enum,
              })
            }}
          </span>
        </span>
        <!-- kiểu Image + Text -->
        <span
          v-else-if="col.formatType === $ms.constant.FormatType.ImageText"
          :class="[`text-${col.align || 'left'} ${col.linkedForm ? 'text-link' : ''}`, 'image-text-cell']"
          :ref="`text-${col.dataField}`"
          :title="titleToolTip(dataRow, col)"
          @click="viewLinkedForm(col, dataRow)"
        >
          <div class="image-container">
            <img
              v-if="dataRow[col.imageField]"
              :src="dataRow[col.imageField]"
              :alt="dataRow[col.dataField] || ''"
              class="app-logo-image"
            />
          </div>
          <span class="text-content">
            {{
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                optionFormat: col.optionFormat,
                enumName: col.enum,
              })
            }}
          </span>
        </span>
        <div
          :class="'parent-' + getEnumClass(col, dataRow[col.dataField])"
          v-else-if="col.formatType === $ms.constant.FormatType.Enum"
        >
          <div
            :class="[col.cssClass, getEnumClass(col, dataRow[col.dataField])]"
            :ref="`text-${col.dataField}`"
            :title="
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                enumName: col.enum,
              })
            "
          >
            {{
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                enumName: col.enum,
              })
            }}
          </div>
        </div>
        <span
          v-else
          :class="[`text-${col.align || 'left'} ${col.linkedForm ? 'text-link' : ''}`]"
          :ref="`text-${col.dataField}`"
          :title="
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
            })
          "
          @click="viewLinkedForm(col, dataRow)"
        >
          {{
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
            })
          }}
        </span>
      </div>
    </td>
    <td :key="100" v-if="$slots.widget" class="ms-td widget-item sticky">
      <slot name="widget" />
    </td>
  </tr>
</template>
<script>
import commonFunction from '@/commons/commonFunction';
// apis
// import fileApi from '@/apis/other/fileAPI';
// utils
// import {getAvatarColor, getInitials, getAvatarColorById} from '@/commons/utils/avatarGenerator';

export default {
  name: 'msTr',
  components: {},
  props: {
    //Lưu thông tin của các cột
    columns: {},
    //Lưu dữ liệu của dòng
    dataRow: {},
    //Ẩn/hiện cột checkbox tích chọn nhiều cột
    multiple: {
      default: false,
      type: Boolean,
    },
    //Trạng thái tích chọn ở cột multiple
    isSelected: {
      default: false,
      type: Boolean,
    },
    index: {
      default: null,
      type: Number,
    },
    serial: {
      default: false,
      type: Boolean,
    },
    currentPage: {
      default: 1,
      type: Number,
    },
    pageSize: {
      default: 20,
      type: Number,
    },
    rowSelected: {
      default: null,
    },
    rowActions: {
      default: null,
      type: [Object, Array],
    },
    actionInlineCount: {
      type: Number,
    },
    disabledCheckedMultipleTbody: {
      default: false,
      type: [Boolean, Function],
    },
    hasLockColumn: {
      type: Boolean,
      default: false,
    },
    isCheckedAll: {
      default: () => false,
      type: Boolean,
    },
    isShowZero: {
      default: () => false,
      type: Boolean,
    },
  },
  created() {
    const me = this;
    me.moreText = me.$t('i18nCommon.command.more');
  },
  computed: {
    /**
     * Action hiển thị trên dòng chọn ngay
     */
    actionInline() {
      let result = [],
        actions = this.rowActions;

      if (actions) {
        if (actions.length > this.actionInlineCount) {
          for (let i = 0; i < this.actionInlineCount - 1; i++) {
            result.push(actions[i]);
          }

          result.push({
            command: 'MORE',
            icon: 'more',
            text: this.moreText,
          });
        } else {
          for (let i = 0; i < actions.length; i++) {
            result.push(actions[i]);
          }
        }
      }

      return result;
    },
    /**
     * Action hiển trong more context
     */
    actionContext() {
      let result = [],
        actions = this.rowActions;

      if (actions && actions.length > this.actionInlineCount) {
        for (let i = this.actionInlineCount - 1; i < actions.length; i++) {
          result.push(actions[i]);
        }
      }

      return result;
    },
    /**
     * Nếu có check all sẽ thực hiện check all
     */
    isChecked() {
      const {disabledCheckedMultipleTbody, isCheckedAll, isSelected} = this;
      return disabledCheckedMultipleTbody ? false : isCheckedAll || isSelected;
    },
  },
  data() {
    return {
      /**
       * Hiển thị row action không
       */
      showRowAction: false,
      /**
       * Style đặt vị trí hiển thị row action
       */
      rowActionStyle: {
        top: 0,
        left: 0,
      },
      // Đánh dấu lỗi khi load ảnh (nvthinh 25.08.2025)
      isImageError: false,
      // đường dẫn ảnh
      imageSrc: '',
    };
  },
  methods: {
    /**
     * @author nvthinh 25.08.2025
     * @description Xử lý lỗi khi load ảnh
     */
    handleOnGetImgError() {
      this.isImageError = true;
    },

    /**
     * @description Lấy đường dẫn ảnh
     * @param {Object} col - Cột
     * @param {Object} dataRow - Dữ liệu dòng
     * @returns {string} Đường dẫn ảnh
     * @author nvthinh 25.08.2025
     */
    getAvatarSrc(col, dataRow) {
      const me = this;
      if (
        !col.imageField ||
        !dataRow[col.imageField] ||
        dataRow[col.imageField] === commonFunction.generateEmptyUUID()
      ) {
        return '';
      }

      let imgSrc = '';
      if (col.isFromMisaId) {
        imgSrc = `${window._misaId.baseUrl}/image/getavatar?userId=${dataRow[col.imageField]}`;
      } else if (col.isFromServer) {
        imgSrc = fileApi.getImageLink(me.$ms.constant.StorageFileType.Attachment, dataRow[col.imageField]);
      } else {
        imgSrc = dataRow[col.imageField];
      }
      return imgSrc;
    },

    /**
     * Tạo màu nền cho avatar placeholder
     * @param {string} text - Text để tạo màu
     * @param {boolean} useNameBased - Có sử dụng tên để tạo màu không
     * @returns {string} Màu hex
     */
    getRandomAvatarColor(text, useIdBasedColor = false, userIdField = 'user_id') {
      const me = this;

      let result = getAvatarColor(text, me.index);
      if (useIdBasedColor) {
        result = getAvatarColorById(me.dataRow[userIdField]);
      }

      me.dataRow.avatarColor = result;

      return result;
    },

    /**
     * Lấy chữ cái đầu để hiển thị trong avatar placeholder
     * Quy tắc:
     * - Nếu tên có 2 từ trở lên: lấy chữ cái đầu của Họ và chữ cái đầu của Tên
     * - Nếu tên chỉ có 1 từ: lấy chữ cái đầu tiên
     * Ví dụ: Nguyễn Văn Hảo => NH, Lê Thành => LT, Tú => T, Tạ Thị Hào Liên => TL
     */
    getAvatarInitial(fullName) {
      return getInitials(fullName);
    },

    //Cập nhật lại độ rộng của cột theo độ rộng cấu hình
    //Created by LTDAT
    styleWidth(col, widget) {
      let rs = {};

      if (col.lock) {
        rs.left = (col.stickyOffset || 0) + 'px';
      }

      if (!widget) {
        rs['max-width'] = col.width + 'px';
      }
      this.$emit('styleColumn', col, this.dataRow, rs);

      return rs;
    },

    drilldownClick(col, dataRow, e) {
      let metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('drilldownClick', metaData, e);
    },

    //(Click vào các cột có dạng số nhiều.(đại diện cho nhiều dòng chi tiết)
    //Created by TVLOI 22.05.2021
    viewMoreDetails(col, dataRow, e) {
      dataRow.moreDetails = true;
      let metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('viewMoreDetails', metaData, e);
    },

    /**
     * Hiển thị form chi tiết khi click vào ô (nếu có config linkedForm)
     * dtnga3 (14.07.2022)
     */
    viewLinkedForm(col, dataRow, e) {
      if (col && col.linkedForm && col.linkedForm != '') {
        this.$emit('viewLinkedForm', col, dataRow, e);
      }
    },

    //Sự kiện click vào nút chọn ở cột multiple
    //Created by LTDAT (28.05.2020)
    //NCPHUOC 28/03/2022: emit checkbox event ra ngoài grid
    checkMultiple(e) {
      const me = this;
      const checked = e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;
      me.$emit('clickMultiple', me.dataRow, checked);
    },

    /**
     * Show tooltip cho nội dung cell
     */
    titleToolTip(dataRow, col) {
      let me = this;
      if (col.formatType == me.$ms.constant.FormatType.Html) {
        if (dataRow[col.dataField]) {
          return me.stripHtml(dataRow[col.dataField]);
        } else {
          return null;
        }
      } else {
        //Format dạng MOREDETAILS
        if (dataRow[col.dataField] === 'MORE_DETAILS') {
          return me.$t('i18nCommon.command.ViewMoreDetails');
        }

        //pvduy 24/04/2021: xử lý riêng toolip giá trị khác trong báo cáo thống kê số lượng theo tình trạng.
        if (col.dataField === 'AssetStatusName' && dataRow[col.dataField] === 'Khác') {
          return 'Báo mất, báo hỏng, đề nghị thanh lý, đang điều chuyển';
        } else {
          return this.$ms.format.formatData(dataRow[col.dataField], {
            formatType: col.formatType,
            enumName: col.enum,
            dataRow: dataRow,
            optionFormat: col.optionFormat,
          });
        }
      }
    },
    /**
     * convert html code to text
     * @author nvthinh 9.7.2025
     */
    stripHtml(value) {
      if (value && typeof value === 'string') {
        // Biểu thức chính quy để thay thế thẻ <br> thành ký tự xuống dòng
        const lineBreakRegex = /<br>/gi;
        let result = value.replace(lineBreakRegex, '\n');

        // Biểu thức chính quy để thay thế các thẻ style thành ký tự rỗng
        const styleTagsRegex = /<b[^>]*>|<\/b>|<i[^>]*>|<\/i>/gi;
        result = result.replace(styleTagsRegex, '');

        // Biểu thức chính quy để thay thế các thẻ khác thành ký tự '; '
        const otherTagsRegex = /<[^>]*>/g;
        result = result.replace(otherTagsRegex, ' ');

        // chuyển các HTML Character Entity thành text thường (bug 100473 - vqphong - 12/06/2024)
        result = new DOMParser().parseFromString(result, 'text/html').documentElement.textContent;

        return result;
      }
      return '';
    },
    showActionSub(action, event) {
      const me = this;
      if (action.subMenu) {
        let liPersent = event.toElement;
        if (liPersent) {
          while (!liPersent.className.contains('actionSub')) {
            liPersent = liPersent.offsetParent;
          }
          let liPosition = liPersent.getBoundingClientRect(); // Position của thẻ li (action cha)
          let [menuSub] = me.$refs.actionSubMenu; // Position menu sub
          let elSub = menuSub.$el; // element sub
          let elSubPosition = menuSub.$el.getBoundingClientRect(); // Position của menusub
          if (elSub) {
            // gán lại style cho  element sub, đang tạm gán thôi, chưa tính trường hợp dàn lên trên nếu top quá to hoặc dàn sang phải nếu left quá nhỏ
            elSub.style.top = liPosition.top + 'px';
            elSub.style.left = liPosition.left - elSubPosition.width + 'px';
          }
        }
      }
    },
    getEnumClass(col, value) {
      if (!col.enum || value === null || value === undefined) {
        return '';
      }

      try {
        let formatValue = Number(value);
        if (Number.isNaN(formatValue)) {
          formatValue = value;
        }

        let enumObj = this.$ms.constant[col.enum];
        if (enumObj) {
          let key = Object.keys(enumObj).find(k => enumObj[k] === formatValue);
          if (key) {
            let className = `${col.enum}-${key}`.toLowerCase();
            return className;
          }
        }
      } catch (error) {
        console.warn('Error getting enum class:', error);
      }

      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsTrViewer.scss';

/* CSS cho kiểu Icon + Text */
.icon-text-cell {
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    flex-shrink: 0;
  }

  .text-content {
    flex: 1;
  }
}

/* CSS cho kiểu Avatar + Text */
.avatar-text-cell {
  display: flex;
  align-items: center;
  gap: 12px;

  .avatar-container {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    position: relative;
  }

  .logo-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  .avatar-placeholder {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    border: 1px solid #e0e0e0;
  }

  .text-content {
    flex: 1;
    min-width: 0; /* Cho phép text truncate nếu cần */
  }
}

/* CSS cho kiểu Image + Text */
.image-text-cell {
  display: flex;
  align-items: center;
  gap: 12px;

  .image-container {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .app-logo-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .text-content {
    flex: 1;
    min-width: 0; /* Cho phép text truncate nếu cần */
  }
}
</style>
